"use client";

import React, { useEffect, useRef } from "react";
import gsap from "gsap";

export default function ScrollIndicator() {
  const mouseRef = useRef<HTMLDivElement>(null);
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!mouseRef.current || !scrollRef.current) return;

    // Create the scroll animation
    const tl = gsap.timeline({ repeat: -1, yoyo: true });

    tl.to(scrollRef.current, {
      y: 8,
      duration: 1.5,
      ease: "power2.inOut",
    });

    return () => {
      tl.kill();
    };
  }, []);

  return (
    <div
      className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center text-slate-400/60 animate-pulse"
    >
      <div
        ref={mouseRef}
        className="w-6 h-10 border-2 border-current rounded-full flex justify-center"
      >
        <div
          ref={scrollRef}
          className="w-1 h-3 bg-current rounded-full mt-2"
        ></div>
      </div>
      <div className="mt-2 text-xs font-medium tracking-wider">SCROLL</div>
    </div>
  );
}
